module.exports = __webpack_public_path__ + "img/icon_jcguizesel.3d3157f3.svg";